import { RouteConfig } from 'vue-router';
import { RouterPath } from '../shared/enums';
import { Role } from '../shared/enums/role.enum';

export default (): Array < RouteConfig > => {
    return [{
            path: RouterPath.PAGE_INVOICE,
            name: 'faturas',
            meta: {role: Role.INVOICE},
            component: () => import ('./components/pages/page-invoice').then(m => m.default)
        },
        {
            path: RouterPath.PAGE_EXTRACT,
            name: 'extrato-vendas',
            meta: {role: Role.INVOICE},
            component: () => import ('./components/pages/page-extract').then(m => m.default)
        }
    ];
};
